// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as React from "react";
import * as Belt_List from "../../../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as ZoneClusterTabItem from "./ZoneClusterTabItem.bs.js";
import * as ModificationLegends from "../../../../../../pricing-dashboard/view/components/components/sidebars/core-pricing/pricing-modification/ModificationLegends.bs.js";
import * as CircularLoader$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as PricingDashboardAssetsManager from "../../../../../../pricing-dashboard/view/assets/PricingDashboardAssetsManager.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

var move_icon = PricingDashboardAssetsManager.getImage("move-icon.svg");

function ApprovedZoneClusterTabView(Props) {
  var allowedUserAction = Props.allowedUserAction;
  var mandatory_campaign = Props.mandatory_campaign;
  var approved_campaigns = Props.approved_campaigns;
  var selected_geo_region = Props.selected_geo_region;
  var selected_vehicle = Props.selected_vehicle;
  var zones = Props.zones;
  var clusters = Props.clusters;
  var user_role = Props.user_role;
  var open_modal = Props.open_modal;
  var setUpdatedStatus = Props.setUpdatedStatus;
  var dispatch = Props.dispatch;
  var sorted_by_priority = List.sort((function (a, b) {
          return a.priority - b.priority | 0;
        }), approved_campaigns);
  var tmp;
  var exit = 0;
  var error;
  var exit$1 = 0;
  if (typeof zones === "number") {
    exit$1 = 3;
  } else {
    switch (zones.TAG | 0) {
      case /* Loading */0 :
          exit$1 = 3;
          break;
      case /* Live */1 :
          var zones$1 = zones._0;
          if (typeof clusters === "number") {
            exit = 1;
          } else {
            switch (clusters.TAG | 0) {
              case /* Loading */0 :
                  exit = 1;
                  break;
              case /* Live */1 :
                  var clusters$1 = clusters._0;
                  tmp = Belt_List.toArray(List.mapi((function (index, campaign) {
                              return React.createElement(ZoneClusterTabItem.make, {
                                          allowedUserAction: allowedUserAction,
                                          priority: index + 1 | 0,
                                          mandatory_campaign: mandatory_campaign,
                                          campaign: campaign,
                                          selected_geo_region: selected_geo_region,
                                          selected_vehicle: selected_vehicle,
                                          zones: zones$1,
                                          clusters: clusters$1,
                                          user_role: user_role,
                                          open_modal: open_modal,
                                          setUpdatedStatus: setUpdatedStatus,
                                          dispatch: dispatch,
                                          key: String(index)
                                        });
                            }), sorted_by_priority));
                  break;
              case /* Error */2 :
                  exit$1 = 3;
                  break;
              
            }
          }
          break;
      case /* Error */2 :
          error = zones._0;
          exit = 2;
          break;
      
    }
  }
  if (exit$1 === 3) {
    if (typeof clusters === "number" || clusters.TAG !== /* Error */2) {
      exit = 1;
    } else {
      error = clusters._0;
      exit = 2;
    }
  }
  switch (exit) {
    case 1 :
        tmp = React.createElement(CircularLoader$Catalyst.make, {});
        break;
    case 2 :
        tmp = React.createElement(ErrorDisplayComponent$Catalyst.make, {
              error: error
            });
        break;
    
  }
  return React.createElement("div", undefined, React.createElement(ModificationLegends.make, {}), tmp);
}

var make = ApprovedZoneClusterTabView;

export {
  move_icon ,
  make ,
  
}
/* move_icon Not a pure module */
